/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LoginRequest } from '../../models/login-request';

export interface ApiIdentityAccountLoginGet$Plain$Params {
  returnUrl?: string;
}

export function apiIdentityAccountLoginGet$Plain(http: HttpClient, rootUrl: string, params?: ApiIdentityAccountLoginGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<LoginRequest>> {
  const rb = new RequestBuilder(rootUrl, apiIdentityAccountLoginGet$Plain.PATH, 'get');
  if (params) {
    rb.query('returnUrl', params.returnUrl, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LoginRequest>;
    })
  );
}

apiIdentityAccountLoginGet$Plain.PATH = '/api/identity/account/login';
